(function () {
  const btn = document.querySelector('[data-wa]');
  if (!btn) return;

  let hiddenOnce = false;

  function handleScroll() {
    if (hiddenOnce) return;

    const y = window.scrollY || document.documentElement.scrollTop || 0;

    if (y > 10) {
      btn.classList.add('is-scrolled');
      hiddenOnce = true; // trava para nunca mais aparecer
      window.removeEventListener('scroll', handleScroll);
    }
  }

  window.addEventListener('scroll', handleScroll, { passive: true });
})();